/**
 *  Javascript code for filtering blog articles/categories and blog single view.
 *
 *  @author Mario Sassmann <mario.sassmann@speedy-space.com>
 */
( function () {

    /**
     * Add the active class to 'blog' list menu item on single post and on blog overview
     * Acutally provided by theme/wordpress.
     * But not working on singe post view and not working when coming overiew page by back button.
     */
    document.getElementById( 'menu-main-menu' ).querySelector( 'a[href="/blog/"]' )
        .parentElement.classList.add( 'current-menu-item' );

    function setResetInactiveByUrl() {
        const current_url = window.location.href;
        const reset_button = document.querySelector( '.search-filter-reset' );

        // filter is active (url parameter present), so set reset button inactive
        if ( current_url.indexOf( '?' ) > -1 && reset_button ) {
            reset_button.classList.add( 'reset-inactive' );
        }
    }

    function moveResetToCategoryList() {
        const category_field_ul = document.querySelector( 'li.sf-field-category > ul' );
        const reset_li = document.querySelector( '.sf-field-reset' );

        if ( category_field_ul && reset_li ) {
            category_field_ul.insertBefore( reset_li, category_field_ul.childNodes[0] );
        }
    }

    document.addEventListener( 'click', function() {
        document.querySelector( '.search-filter-reset' ).classList.add( 'reset-inactive' );
    } );

    /**
     * Call both when site is rendered
     */
    document.addEventListener( 'DOMContentLoaded', () => {
        moveResetToCategoryList();
        setResetInactiveByUrl();
    } );

    /**
     * same here, but jQuery needed because of S&F API depending on jquery events
     */
    jQuery( document ).on( 'sf:ajaxfinish', () => {
        moveResetToCategoryList();
        setResetInactiveByUrl();
    } );

} ) ();
